<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-14 09:44:45
 * @LastEditTime: 2020-07-07 14:24:45
 * @LastEditors: Please set LastEditors
 -->
<!--  -->
<template>
  <div style="position: absolute; bottom: 5px;left: 5px;z-index: 100;">
        <div>
          <img
            style="float:left"
            src="../../../assets/onlineMap/tdt.png"
            width="53px"
            height="22px"
            opacity="0"
          />
          <div
            class="sheetNumber"
            style="float:left;margin-left:5px;white-space:nowrap;color:#000;font-size:12px"
          >GS(2025)1508号-甲测资字11110974</div>
        </div>
      </div>
</template>

<script>
export default {
  name: "UCAptitude",

  data() {
    return {};
  },

  computed: {},

  mounted() {},

  methods: {
    init() {}
  }
};
</script>

<style lang="less">

</style>